export default {"src":"/_next/static/media/notes.8c3b5e72.svg","height":196,"width":276,"blurWidth":0,"blurHeight":0};